import axios from 'axios';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';

import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

export default function UserSettings() {
  const { userId } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const showModal = (itemId) => {
    setOpenModal(itemId);
  };
  return (
    <>
      <div className='pl-8 pt-8'>
        <Card
          sx={{
            p: 3,
            borderRadius: 3,
            width: '70%',
            height: '100px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className=' text-gray-600'>Change user password</div>
          <div>
            <Button
              sx={{ textTransform: 'none' }}
              variant='outlined'
              className='rounded-md border border-cyan-600 px-6 font-bold text-cyan-600'
              onClick={showModal}
            >
              Change
            </Button>
          </div>
        </Card>
      </div>
      <ChangeUserPassword
        openModal={openModal}
        setOpenModal={setOpenModal}
        fetchData={() => {}}
        userId={userId}
      />
    </>
  );
}

export function ChangeUserPassword({
  openModal,
  setOpenModal,
  fetchData,
  userId,
}) {
  const url = `${process.env.REACT_APP_API_URL}/admin/v3/users/${userId}/change-password-by-admin`;
  const { auth } = useAuth();

  const [password, setPassword] = useState();

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChange = () => {
    const formData = {
      password: password.password,
    };

    axios
      .post(`${url}`, formData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Updated successfully:', response);
        setPassword({ ...password });
        fetchData();
        toast.success('Updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(`Error: ${error.response.data.system.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModal}
      onClose={() => setOpenModal(false)}
    >
      <DialogTitle>Change User Password</DialogTitle>

      <DialogContent>
        <div className='flex justify-between'>
          <br />

          <Box flex={1} mr={1}>
            <Typography fontFamily='Poppins'>New Password*</Typography>
            <FormControl sx={{ pt: 2 }} className='py-2'>
              <OutlinedInput
                fullWidth
                size='medium'
                sx={{ width: '490px' }}
                placeholder='Enter new password'
                userId='password'
                type={showPassword ? 'text' : 'password'}
                value={password?.password || ''}
                onChange={(e) =>
                  setPassword({
                    ...password,
                    password: e.target.value,
                  })
                }
                endAdornment={
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge='end'
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <br />
            <br />
          </Box>
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModal(false)}
          color='error'
        >
          Cancel
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => {
            handleChange();
            handleClose();
          }}
          color='primary'
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
